import { createSlice } from '@reduxjs/toolkit';
import { createApp, fetchApps, updateApp, deleteApp } from './apps.actions';

const initialState = {
  apps: [],
  metaData: { total: 0, page: 1, perPage: 10 },

  isLoadingCreateApp: false,
  isLoadingFetchApps: false,
  isLoadingUpdateApp: false,
  isLoadingDeleteApp: false
};

const appsSlice = createSlice({
  name: 'apps',
  initialState,
  reducers: {
    clearAppsState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(createApp.pending, (state) => {
      state.isLoadingCreateApp = true;
    });
    builder.addCase(createApp.fulfilled, (state) => {
      state.isLoadingCreateApp = false;
    });
    builder.addCase(createApp.rejected, (state) => {
      state.isLoadingCreateApp = false;
    });

    builder.addCase(fetchApps.pending, (state) => {
      state.isLoadingFetchApps = true;
    });
    builder.addCase(fetchApps.fulfilled, (state, action) => {
      state.apps = action.payload.data;
      state.metaData = action.payload.metaData;
      state.isLoadingFetchApps = false;
    });
    builder.addCase(fetchApps.rejected, (state) => {
      state.isLoadingFetchApps = false;
    });

    builder.addCase(updateApp.pending, (state) => {
      state.isLoadingUpdateApp = true;
    });
    builder.addCase(updateApp.fulfilled, (state) => {
      state.isLoadingUpdateApp = false;
    });
    builder.addCase(updateApp.rejected, (state) => {
      state.isLoadingUpdateApp = false;
    });

    builder.addCase(deleteApp.pending, (state) => {
      state.isLoadingDeleteApp = true;
    });
    builder.addCase(deleteApp.fulfilled, (state) => {
      state.isLoadingDeleteApp = false;
    });
    builder.addCase(deleteApp.rejected, (state) => {
      state.isLoadingDeleteApp = false;
    });
  }
});

export const { clearAppsState } = appsSlice.actions;

export default appsSlice.reducer;
